var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("camara")]),_c('input',{attrs:{"type":"file","value":"Camaras"},on:{"change":_vm.uploadCamara}}),_c('p',[_vm._v("flujo")]),_c('input',{attrs:{"type":"file","value":"red_as"},on:{"change":_vm.uploadFlujo}}),_c('b-button',{on:{"click":_vm.calcular}},[_vm._v("Join")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }